import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-terms-view',
	templateUrl: './terms-view.component.html',
	styleUrls: ['./terms-view.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TermsViewComponent implements OnInit {
	pdfTermosPj: any;
	text: string;
	hideBtn = false;
	@Output('back') back: EventEmitter<any> = new EventEmitter();

	constructor(private sanitizer: DomSanitizer) { }

	ngOnInit() {
		let urlTermos = '';

		if (Auth.getInstance().getUser().personType === 'F') {
			urlTermos = 'assets/pdf/Termos_e_Condicoes_Conta_de_Depositos.pdfassets/pdf/Termos_e_Condicoes_Conta_de_Depositos.pdf#toolbar=0&navpanes=0&scrollbar=0';
		} else {
			urlTermos = 'assets/pdf/Termos_e_Condicoes_Conta_de_Depositos.pdfassets/pdf/Termos_e_Condicoes_Conta_de_Depositos.pdf#toolbar=0&navpanes=0&scrollbar=0';
		}


		this.pdfTermosPj = this.sanitizer.bypassSecurityTrustResourceUrl(urlTermos);
	}

	print() {
		this.hideBtn = true;
		window.open('assets/pdf/Termos_e_Condicoes_Conta_de_Depositos.pdf', '_blank').focus();
	}

	toBack() {
		this.back.next(true);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/terms-of-use/terms-view/terms-view.component.ts